import { render } from "./PopUpPreviewFile.vue?vue&type=template&id=b9642a32"
import script from "./PopUpPreviewFile.vue?vue&type=script&lang=js"
export * from "./PopUpPreviewFile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__